<script setup lang="ts">
import logo from "assets/tepper-logo.svg";
import { useNuxtAuth } from "@kopf3/adapt-oidc-component";

const auth = useNuxtAuth();

function logout() {
    if (auth.isAuthenticated.value) {
        auth.logout();
    }
}
</script>

<template>
    <v-app-bar app class="toolbar">
        <v-img :src="logo" alt="Company Logo" class="tepper-logo" @click="navigateTo('/')" />
        <v-spacer />
        <div v-if="auth.isAuthenticated && auth.user">
            <span class="user">Eingeloggt als: {{ auth.user.value?.profile?.name }}</span>
            <v-btn icon class="logout-btn" title="Abmelden" :rounded="false" @click="logout">
                <v-icon>mdi-logout</v-icon>
            </v-btn>
        </div>
    </v-app-bar>
</template>

<style scoped>
.toolbar {
    padding: 0 16px;
    box-sizing: border-box;

    .tepper-logo {
        max-width: 100px;
        max-height: 50px;

        &:hover {
            cursor: pointer;
        }
    }

    .user {
        font-size: 14px;
    }

    .logout-btn:hover {
        border-radius: 4px !important;
    }
}
</style>
